import './person/person';
import './bankNumbers/bankNumbers';
import './accountswitchDates/accountswitchDates';
import './advancedSettings/advancedSettings';
